/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import React from 'react';
import ReactTable from 'react-table';

import ExportSection from '../ElectronicJournal/ExportSection';
import NposTable from '../ElectronicJournal/Npos/search-results/NposTable';

import 'react-table/react-table.css';

class TableRowClick extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredIndex: null,
    };
  }

  render = () => (
    this.props.showNewUi
      ? (
        <NposTable
          columns={this.props.columns}
          data={this.props.data}
          errorMessage={this.props.errorMessage}
          fetched={this.props.fetched}
          fetching={this.props.fetching}
          handleClick={this.props.handleClick}
          isTransactionSelected={this.props.isTransactionSelected}
          viewingIndex={this.props.viewingIndex}
        />
        )
      : this.props.fetching && !this.props.fetched
        ? <></>
        : this.props.fetched && (
          this.props.data.length > 0
            ? (
              <div className="pt4-sm">
                {!this.props.isNpos && <ExportSection data={this.props.data} storeInfo={this.props.storeInfo} title={this.props.title} />}
                <ReactTable
                  className="-striped -highlight"
                  columns={this.props.columns.map((col) => ({ ...col, headerStyle: { background: 'black', color: 'white', fontSize: '20px' } }))}
                  data={this.props.data}
                  defaultPageSize={this.props.showPagination ? this.props.defaultPageSize : this.props.data.length}
                  getTdProps={() => ({
                    style: {
                      display: 'flex', flexDirection: 'column', justifyContent: 'center', whiteSpace: 'unset',
                    },
                  })}
                  getTrProps={(state, rowInfo) => {
                    if (rowInfo && rowInfo.row) {
                      return {
                        'data-testid': `table-row-${rowInfo.original.id ?? rowInfo.index}`,
                        onClick: () => {
                          this.props.handleClick(rowInfo.original, rowInfo.index);
                        },
                        onMouseLeave: () => {
                          this.setState({ hoveredIndex: null });
                        },
                        onMouseOver: () => {
                          this.setState({ hoveredIndex: rowInfo.index });
                        },
                        style: {
                          background: rowInfo.index === this.props.activeRow
                            ? '#FA5400'
                            : rowInfo.index === this.state.hoveredIndex ? '#CCCCCC' : '',
                          color: rowInfo.index === this.props.activeRow ? 'white' : '',
                          cursor: 'pointer',
                          whiteSpace: 'unset',
                        },
                      };
                    } else {
                      return {};
                    }
                  }}
                  showPagination={this.props.showPagination}
                  style={{ height: 'auto' }}
                />
              </div>
            )
            : <p className="body-1 text-color-accent p4-sm">No Matches Found.</p>
        )
  );
}

TableRowClick.defaultProps = {
  activeRow: undefined,
  defaultPageSize: 10,
  errorMessage: null,
  fetched: true,
  fetching: false,
  handleClick: () => null,
  isTransactionSelected: false,
  showPagination: false,
  viewingIndex: null
};

TableRowClick.propTypes = {
  activeRow: PropTypes.number,
  columns: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  defaultPageSize: PropTypes.number,
  errorMessage: PropTypes.string,
  fetched: PropTypes.bool,
  fetching: PropTypes.bool,
  handleClick: PropTypes.func,
  isNpos: PropTypes.bool.isRequired,
  isTransactionSelected: PropTypes.bool,
  showNewUi: PropTypes.bool.isRequired,
  showPagination: PropTypes.bool,
  storeInfo: PropTypes.shape({
    storeLocale: PropTypes.string.isRequired,
    storeTimezone: PropTypes.string.isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
  viewingIndex: PropTypes.number,
};

export default TableRowClick;
